var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { useGetModuleBuilderDropdownQuery, useGetModuleFieldsBuilderQuery, } from "@/store/api";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
export default function Enum(_a) {
    var _this = this;
    var _b;
    var settings = _a.settings, _c = _a.updated, updated = _c === void 0 ? false : _c, error = _a.error, updateSettings = _a.updateSettings;
    var _d = useParams(), packagesName = _d.packagesName, moduleName = _d.moduleName, type = _d.type, menu = _d.menu, fieldName = _d.fieldName;
    var t = useTranslation(["DynamicFields"]).t;
    var navigate = useNavigate();
    var _e = useState(settings || {}), valueSettings = _e[0], setValue = _e[1];
    var dropdowns_list = useAppSelector(function (state) { return state.moduleBuilder.studio_dropdowns; });
    useEffect(function () {
        settings && setValue(settings);
    }, [settings]);
    var _f = useState(), fieldDefs = _f[0], setFieldDefs = _f[1];
    var listFieldDefs = useGetModuleFieldsBuilderQuery({
        params: {
            package: "",
            module: moduleName,
            lang: "en_us",
        },
    }).data;
    useEffect(function () {
        if (listFieldDefs) {
            setFieldDefs(listFieldDefs.data.fieldsData);
        }
    }, [listFieldDefs]);
    var handleInputChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
        var _a, name, value, type, checked, newValue;
        return __generator(this, function (_b) {
            _a = event.target, name = _a.name, value = _a.value, type = _a.type, checked = _a.checked;
            newValue = String(type === "checkbox"
                ? Number(checked)
                : name === "vname"
                    ? value.toUpperCase()
                    : value);
            setValue(function (prevValue) {
                var _a;
                return (__assign(__assign({}, prevValue), (_a = {}, _a[name] = newValue, _a)));
            });
            updateSettings(name, newValue);
            return [2 /*return*/];
        });
    }); };
    var convertEnabledDisabledValue = function (value) {
        if (value === "enabled")
            return "1";
        if (value === "disabled")
            return "0";
        return value;
    };
    var dropdown_response = useGetModuleBuilderDropdownQuery({
        dropdown: valueSettings.options || "account_type_dom",
        lang: "en_us",
    }).data;
    var _g = useState(valueSettings.default || ""), selectedValue = _g[0], setSelectedValue = _g[1];
    var listDropdown = useMemo(function () {
        if (!dropdown_response) {
            return;
        }
        return dropdown_response.data.dropdown;
    }, [dropdown_response]);
    var _h = useState(error || ""), errorInput = _h[0], setErrorInput = _h[1];
    var isStringInObjectName = function (string) {
        var lowerCaseString = string.toLowerCase();
        return fieldDefs === null || fieldDefs === void 0 ? void 0 : fieldDefs.some(function (obj) { return obj.name.toLowerCase() === lowerCaseString; });
    };
    var firstDropdownKey = dropdowns_list && Object.keys(dropdowns_list)[0];
    var firstDropdownValue = dropdowns_list && ((_b = dropdowns_list[firstDropdownKey]) === null || _b === void 0 ? void 0 : _b.name);
    // Set default value for options if not already set
    useEffect(function () {
        var _a;
        if (!valueSettings.options && dropdowns_list) {
            var firstDropdownKey_1 = Object.keys(dropdowns_list)[0];
            var firstDropdownValue_1 = (_a = dropdowns_list[firstDropdownKey_1]) === null || _a === void 0 ? void 0 : _a.name;
            if (firstDropdownValue_1) {
                setValue(function (prevSettings) { return (__assign(__assign({}, prevSettings), { options: firstDropdownValue_1 })); });
                updateSettings("options", firstDropdownValue_1);
            }
        }
    }, [dropdowns_list, valueSettings, setValue]);
    return (_jsxs(_Fragment, { children: [_jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_NAME") }) }), _jsxs("td", { children: [updated ? (_jsx("label", { children: valueSettings.name })) : (_jsx("input", { value: valueSettings.name || "", name: "name", className: "bg-[rgb(var(--color-gray-100))]", type: "text", onChange: function (e) {
                                    handleInputChange(e);
                                    var isExist = isStringInObjectName(e.target.value);
                                    var vnameLabel = "LBL_".concat(e.target.value);
                                    if (!updated && e.target.value) {
                                        if (isExist) {
                                            setErrorInput("Field name exist");
                                        }
                                        else {
                                            setErrorInput("");
                                        }
                                        updateSettings("labelValue", e.target.value);
                                        updateSettings("vname", vnameLabel.toUpperCase());
                                    }
                                } })), errorInput && _jsx("span", __assign({ className: "text-red-400 m-1" }, { children: errorInput }))] })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_DISPLAY_LABEL") }) }), _jsx("td", { children: _jsx("input", { value: valueSettings.labelValue || "", name: "labelValue", type: "text", className: "bg-[rgb(var(--color-gray-100))]", onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_LABEL") }) }), _jsx("td", { children: _jsx("input", { value: valueSettings.vname || "", name: "vname", type: "text", className: "".concat(!updated ? "bg-[rgb(var(--color-gray-100))]" : ""), disabled: updated, onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_HELP_TEXT") }) }), _jsx("td", { children: _jsx("input", { value: valueSettings.help || "", name: "help", type: "text", className: "bg-[rgb(var(--color-gray-100))]", onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_COMMENT_TEXT") }) }), _jsx("td", { children: _jsx("input", { value: valueSettings.comment || "", name: "comment", type: "text", className: "bg-[rgb(var(--color-gray-100))]", onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("LBL_DROP_DOWN_LIST") }) }), _jsx("td", { children: _jsx("select", __assign({ name: "options", value: valueSettings.options || "", onChange: function (e) {
                                handleInputChange(e);
                                updateSettings("default", "");
                            } }, { children: dropdowns_list &&
                                Object.values(dropdowns_list).map(function (dropdown, index) { return (_jsx("option", __assign({ value: dropdown.name }, { children: dropdown.name }), index)); }) })) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_MASS_UPDATE") }) }), _jsx("td", { children: _jsx("input", { name: "massupdate", checked: typeof valueSettings.massupdate === "boolean"
                                ? valueSettings.massupdate
                                : Boolean(Number(valueSettings.massupdate)) || false, type: "checkbox", onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_REQUIRED_OPTION") }) }), _jsx("td", { children: _jsx("input", { type: "checkbox", name: "required", checked: typeof valueSettings.required === "boolean"
                                ? valueSettings.required
                                : Boolean(Number(valueSettings.required)) || false, onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_AUDIT") }) }), _jsx("td", { children: _jsx("input", { type: "checkbox", name: "audited", checked: typeof valueSettings.audited === "boolean"
                                ? valueSettings.audited
                                : Boolean(Number(valueSettings.audited)) || false, onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_INLINE_EDIT_TEXT") }) }), _jsx("td", { children: _jsx("input", { type: "checkbox", name: "inline_edit", checked: typeof valueSettings.inline_edit === "boolean"
                                ? valueSettings.inline_edit
                                : Boolean(Number(valueSettings.inline_edit)) || false, onChange: handleInputChange }) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_IMPORTABLE") }) }), _jsx("td", { children: _jsxs("select", __assign({ name: "importable", value: valueSettings.importable || "", onChange: handleInputChange }, { children: [_jsx("option", __assign({ value: "true" }, { children: t("Yes") })), _jsx("option", __assign({ value: "false" }, { children: t("No") })), _jsx("option", __assign({ value: "true" }, { children: t("Required") }))] })) })] }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("label", { children: t("COLUMN_TITLE_DUPLICATE_MERGE") }) }), _jsx("td", { children: _jsxs("select", __assign({ value: convertEnabledDisabledValue(valueSettings.duplicate_merge) || "0", name: "duplicate_merge_dom_value", onChange: function (e) {
                                handleInputChange(e);
                                var dp_merge = e.target.value === "1" ? "enabled" : "disabled";
                                updateSettings("duplicate_merge", dp_merge);
                                updateSettings("duplicate_merge_dom", e.target.value);
                            } }, { children: [_jsx("option", __assign({ value: "1" }, { children: t("Enabled") })), _jsx("option", __assign({ value: "0" }, { children: t("Disabled") }))] })) })] })] }));
}
